import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import { browserHistory } from "react-router"
import TagList from "../elements/TagList"
import { addTag } from "../../actions"
import { injectIntl, FormattedMessage } from "react-intl"
import { default as sharedMessages } from "../../messages/index"

export class Tags extends Component {
  static propTypes = {
    userAddable: PropTypes.bool.isRequired,
    resource: PropTypes.object.isRequired
  }

  handleAddTag = (tag, uuid) => {
    return addTag(uuid, tag)
      .then(res => {
        return new Promise((resolve, reject) =>
          this.props.relay.forceFetch(null, ({ done, error }) => {
            if (done) {
              resolve()
            } else if (error) {
              reject(error)
            }
          })
        )
      })
      .catch(err => {
        if (err.message === "loggedOut") {
          browserHistory.push(`/login?next=/item/${uuid}?tag=${tag}`)
        } else {
          throw err
        }
      })
  }

  render() {
    const {
      intl,
      userAddable,
      resource: { id, custom_fields }
    } = this.props

    const { subject, tags } = JSON.parse(custom_fields)

    return (
      <section className="c-article__details">
        <h3>
          <FormattedMessage {...sharedMessages.taxonomy} />
        </h3>
        {subject && !!subject.value.length && (
          <dl className="c-article__defs">
            <TagList
              title={intl.formatMessage(sharedMessages.formTags)}
              tags={subject.value}
              handleTagClick={tag => browserHistory.push("/search?tags=" + tag)}
              extraClasses="list__def list__def--inline"
            />
          </dl>
        )}
        <dl className="c-article__defs" itemProp="keywords">
          <TagList
            title={intl.formatMessage(sharedMessages.communityTags)}
            resourceId={id}
            userAddable={userAddable}
            handleAddTag={this.handleAddTag}
            handleTagClick={tag => browserHistory.push("/search?tags=" + tag)}
            tags={tags ? tags.value : []}
            extraClasses="list__def list__def--inline"
          />
        </dl>
      </section>
    )
  }
}

export default Relay.createContainer(injectIntl(Tags), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        custom_fields
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/Tags.js